import { ICalendarDate } from '../Calendar';
import { isDateBGreaterThanDateA, isDateExists, isTwoDatesEqual, today } from './dateFormatters';
export const DateFormats = {
  'YYYY.MM.DD': 'YYYY.MM.DD',
  'YYYY.DD.MM': 'YYYY.DD.MM',
  'DD.MM.YYYY': 'DD.MM.YYYY'
};
export const availableFormatsMap = {
  'YYYY.MM.DD': ['year', 'monthIndex', 'day'],
  'YYYY.DD.MM': ['year', 'day', 'monthIndex'],
  'DD.MM.YYYY': ['day', 'monthIndex', 'year']
};
export function validateStringAsPositiveNumeric(val) {
  return /^\d+$/.test(val);
}
export function validateStringAsYearNum({
  value,
  yearsFrom = today.year - 10,
  yearsTill = today.year + 10
}) {
  if (!validateStringAsPositiveNumeric(value) || parseInt(value) < yearsFrom || parseInt(value) > yearsTill) {
    return false;
  }
  return true;
}
export function validateStringAsMonthNum({
  value
}) {
  if (!validateStringAsPositiveNumeric(value) || parseInt(value) < 1 || parseInt(value) > 12) return false;
  return true;
}
export function validateStringAsDayNum({
  value
}) {
  if (!validateStringAsPositiveNumeric(value) || parseInt(value) < 1 || parseInt(value) > 31) return false;
  return true;
}
export function parseInputStringToSingleDate({
  inputString,
  separator = '.',
  dateFormat = DateFormats['YYYY.MM.DD'],
  yearsFrom = today.year - 10,
  yearsTill = today.year + 10
}) {
  const datePartialsOrder = availableFormatsMap[dateFormat];
  const values = inputString.split(separator);
  if (values.length !== 3 || !validateStringAsYearNum({
    value: values[datePartialsOrder.indexOf('year')],
    yearsFrom,
    yearsTill
  }) || !validateStringAsMonthNum({
    value: values[datePartialsOrder.indexOf('monthIndex')]
  }) || !validateStringAsDayNum({
    value: values[datePartialsOrder.indexOf('day')]
  })) {
    return null;
  }
  const date = {
    year: parseInt(values[datePartialsOrder.indexOf('year')]),
    monthIndex: parseInt(values[datePartialsOrder.indexOf('monthIndex')]) - 1,
    day: parseInt(values[datePartialsOrder.indexOf('day')])
  };
  if (!isDateExists(date)) return null;
  return date;
}
export function transformSingleDateToInputString({
  date,
  separator = '.',
  dateFormat = DateFormats['YYYY.MM.DD']
}) {
  const partialsOrder = availableFormatsMap[dateFormat];
  const result = partialsOrder.map(partial => {
    if (partial === 'monthIndex') return date[partial] + 1;
    return date[partial];
  }).join(separator);
  return result;
}
export function parseInputStringToRangeDates({
  inputString,
  rangeDivider = ' - ',
  separator = '.',
  dateFormat = DateFormats['YYYY.MM.DD']
}) {
  const rangeDatesStrings = inputString.split(rangeDivider);
  if (rangeDatesStrings.length !== 2) return null;
  const dateOne = parseInputStringToSingleDate({
    inputString: rangeDatesStrings[0],
    separator,
    dateFormat
  });
  const dateTwo = parseInputStringToSingleDate({
    inputString: rangeDatesStrings[1],
    separator,
    dateFormat
  });
  if (!dateOne && !dateTwo) return null;
  return [dateOne || undefined, dateTwo || undefined];
}
export function transformRangeDatesToInputString({
  dateOne,
  dateTwo,
  rangeDivider = ' - ',
  separator = '.',
  dateFormat = DateFormats['YYYY.MM.DD']
}) {
  if (!dateOne && !dateTwo) return '';
  const resultDateOne = dateOne ? `${transformSingleDateToInputString({
    date: dateOne,
    separator,
    dateFormat
  })}` : '...';
  const resultDateTwo = dateTwo ? `${transformSingleDateToInputString({
    date: dateTwo,
    separator,
    dateFormat
  })}` : '...';
  return `${resultDateOne}${rangeDivider}${resultDateTwo}`;
}
export function validateSingleDate(date) {
  if (!date) return false;
  if (!isDateExists(date)) {
    process.env.NODE_ENV === 'development' && console.warn('Некорректное значение даты');
    return false;
  }
  return true;
}
export function validateRangeDates(dateOne, dateTwo) {
  if (!dateOne || !dateTwo) return false;
  if (!isDateExists(dateOne) || !isDateExists(dateTwo)) {
    process.env.NODE_ENV === 'development' && console.warn('Передано одно или оба некорректных значения');
    return false;
  }
  if (isTwoDatesEqual(dateOne, dateTwo)) {
    process.env.NODE_ENV === 'development' && console.warn('Переданы одинаковые значения');
    return false;
  }
  if (isDateBGreaterThanDateA(dateTwo, dateOne)) {
    process.env.NODE_ENV === 'development' && console.warn('Первая дата не может быть старше второй');
    return false;
  }
  return true;
}